import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { usePeopleChartsDataContext } from './hooks/usePeopleChartsDataContext';

export const Indicators = () => {
    const { chartData } = usePeopleChartsDataContext();

    return (
        <div
            className="w-100"
            style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}
        >
            <Card
                title="Jovens (-18)"
                value={number.formatToBRNumber(
                    chartData?.indicators?.young || 0
                )}
            />
            <Card
                title="Adultos"
                value={number.formatToBRNumber(
                    chartData?.indicators?.adults || 0
                )}
            />
            <Card
                title="Idosos"
                value={number.formatToBRNumber(
                    chartData?.indicators?.elderlies || 0
                )}
            />
        </div>
    );
};
